import React from 'react';
import PropTypes from 'prop-types';

import styles from './FormNote.scss';

const FormNote = ({ title, text, style }) => {
  return (
    <div className={`FormNote${style ? ` FormNote--${style}` : ''}`}>
      <p className="FormNote__text">
        {title ? <span className="FormNote__title">{title}</span> : null} {text}
      </p>
    </div>
  );
};

FormNote.propTypes = {
  title: PropTypes.node,
  text: PropTypes.node,
  style: PropTypes.oneOf(['two-lines']),
};

export default FormNote;
